import React from "react";

const NoPermissionToView: React.FC<React.PropsWithChildren<unknown>> = () => {
  return <div>You do not have permission to view this</div>;
};

export default NoPermissionToView;
